import './FilterComposition.css';
export var FilterCompositionApplyButtonSlot = '_1ru5wqrb-3-15-1';
export var FilterCompositionContainer = '_1ru5wqr0-3-15-1';
export var FilterCompositionCustomGroupA = '_1ru5wqr3-3-15-1';
export var FilterCompositionCustomGroupB = '_1ru5wqr5-3-15-1';
export var FilterCompositionCustomGroupC = '_1ru5wqr6-3-15-1';
export var FilterCompositionCustomGroupD = '_1ru5wqr7-3-15-1';
export var FilterCompositionCustomGroupE = '_1ru5wqre-3-15-1';
export var FilterCompositionFilterFieldSlot = '_1ru5wqra-3-15-1';
export var FilterCompositionForm = '_1ru5wqrd-3-15-1';
export var FilterCompositionLayout = '_1ru5wqr2-3-15-1';
export var FilterCompositionRoot = '_1ru5wqr1-3-15-1';
export var FilterCompositionRow1Item = '_1ru5wqr9-3-15-1';
export var FilterCompositionSegmentsSlot = '_1ru5wqr4-3-15-1';
export var FilterCompositionTFSSlot = '_1ru5wqr8-3-15-1';
export var FilterCompositionTabletRowBreak = '_1ru5wqrc-3-15-1';